import { RootState } from '../store';

export const selectLocationOptions = (state: RootState) => state.location.locationOptions;

export const selectLocationOptionsRequestStatus = (state: RootState) => state.location.locationOptionsRequestStatus;
